import './Footer.css';

const quickLinks = [
  { label: 'Home', to: '/' },
  { label: 'SAT Prep Programs', to: '/sat-prep' },
  { label: 'ACT Tutoring', to: '/act-tutoring' },
  { label: 'English / ELA Tutoring', to: '/english-tutoring' },
  { label: 'AP & Honors Tutoring', to: '/ap-tutoring' },
  { label: 'College Essay Coaching & Counseling', to: '/college-counseling' },
  { label: 'About Us', to: '/about' },
  { label: 'Contact Us', to: '/contact' },
  { label: 'Question Bank', to: '/subjects' },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container footer-inner">
          <div className="footer-brand">
            <img
              src="/logo.svg"
              alt="Scholar Sphere"
              className="footer-logo-img"
            />
            <p className="footer-tagline">
              Expert academic support, test prep, and college admissions guidance
              for students in Grades 6–12.
            </p>
          </div>

          <div className="footer-col">
            <h4 className="footer-col-title">Quick links</h4>
            <ul>
              {quickLinks.map(l => (
                <li key={l.label}><a href={l.to}>{l.label}</a></li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-col-title">Contact us</h4>
            <ul>
              <li><a href="mailto:contact@scholar-sphere.com">contact@scholar-sphere.com</a></li>
              <li><a href="#">Facebook</a></li>
              <li><a href="#">Youtube</a></li>
              <li><a href="#">Instagram</a></li>
            </ul>
          </div>

          <div className="footer-col footer-col-wide">
            <h4 className="footer-col-title">Stay connected with us</h4>
            <p className="footer-nl-heading">Join Our Scholar Sphere Community!</p>
            <p className="footer-nl-sub">
              Subscribe for updates on tutoring programs, study resources, and upcoming events.
            </p>
            <form className="nl-form" onSubmit={e => e.preventDefault()}>
              <input type="email" placeholder="Email" />
              <button type="submit" className="btn-gold nl-btn">Subscribe</button>
            </form>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <div className="footer-legal-links">
            <a href="/terms">Terms and conditions</a>
            <a href="#">Legal Disclaimer</a>
            <a href="/privacy">Privacy Policy</a>
          </div>
          <p className="footer-copy">Copyright © Scholar Sphere. All right reserved.</p>
        </div>
      </div>
    </footer>
  );
}
